module.exports = __webpack_public_path__ + "media/images/countrysquared/dk-19e7d6d040412d39c7a0dd6dafceff0f.svg";